module.exports = __webpack_public_path__ + "img/gruppi_mail_smartbook.5e2cec47.png";